import { useQueryClient } from "@tanstack/react-query";
import { $api, fetchClient } from "../generated/client";

type GetVariantsFromProduct = {
  shopId: string;
  productId: string;
  returnRequestId: string;
  lineItemId: string;
};

export async function getVariantFromProduct({
  productId,
  shopId,
  returnRequestId,
  lineItemId,
}: GetVariantsFromProduct) {
  const { data, error } = await fetchClient.GET(
    "/shops/{shopId}/return-requests/{productId}/variants",
    {
      params: {
        path: { shopId, productId },
        query: { returnRequestId, lineItemId },
      },
    },
  );

  if (error) throw error;

  return data;
}

export const useGetVarantFromProduct = ({
  shopId,
  productId,
  returnRequestId,
  lineItemId,
}: {
  shopId: string;
  productId: string;
  returnRequestId: string;
  lineItemId: string;
}) => {
  const query = $api.useQuery(
    "get",
    "/shops/{shopId}/return-requests/{productId}/variants",
    {
      params: {
        path: { shopId, productId },
        query: { returnRequestId, lineItemId },
      },
    },
  );
  return query;
};

type UseInvalidateVariantsParams = {
  shopId: string;
  returnRequestId: string;
  lineItemId: string;
  productId: string;
};

export function useInvalidateReturnRequest() {
  const queryClient = useQueryClient();

  return (params: UseInvalidateVariantsParams) => {
    queryClient.invalidateQueries({
      queryKey: [
        "get",
        "/shops/{shopId}/return-requests/{productId}/variants",
        {
          path: { shopId: params.shopId, productId: params.productId },
          query: {
            returnRequestId: params.returnRequestId,
            lineItemId: params.lineItemId,
          },
        },
      ],
    });
  };
}
